<template>
    <div>
        <div class="container" v-if="listOfArtists.length > 0">
            <div class="talent__view">
                <button type="button" aria-label="Grid View" class="talent-view-grid active">
                    <svg width="16" height="16" aria-hidden="true">
                        <use href="/img/svg/grid.svg#grid"></use>
                    </svg>
                </button>
                <button type="button" aria-label="List View" class="talent-view-list">
                    <svg width="16" height="16" aria-hidden="true">
                        <use href="/img/svg/symbol-defs.svg#icon-list"></use>
                    </svg>
                </button>
            </div>
            <ul
                class="talent talent_grid talent_grid_lg"
            >
                <li
                    class="talent__item"
                    v-for="artist in listOfArtists"
                    :key="artist.id"
                >
                    <div class="talent__inner">
                        <a :href="getArtistLink(artist.id)" class="talent__link">
                            <img :src="getNameOfAvatar(artist.file_avatar?.file_path)" alt="Artist Photo" class="talent__photo">
                        </a>
                        <div class="talent__holder">
                            <h2 class="talent__name"><strong>{{ artist.stage_name }} </strong></h2>
                            <p
                                class="talent__category m-0"
                                v-for="category in artist.categories"
                                :key="category.id"
                            >
                                {{ category.name }}
                            </p>
                            <p class="talent__country m-0">{{ artist.supplemental_title }}</p>
                        </div>
                    </div>
                    <a :href="getArtistLink(artist.id)" class="btn btn_golden view-profile"><span>profile</span></a>
                </li>

            </ul>
            <div class="text-center pt-5 wow zoomIn" data-wow-duration="2.0s" v-show="hasMore" >
                <a class="btn btn_primary-outline" @click="showMoreArtists">Show More</a>
            </div>
        </div>
        <div class="tab-pane" id="second" v-else>
            <div class="categories__empty">
                <svg width="45" height="45">
                    <use href="/img/svg/symbol-defs.svg#icon-cinema"></use>
                </svg>
                <p>There are no artists</p>
            </div>
        </div>
    </div>
</template>

<script>
import {mapActions, mapState} from "pinia";
import {useClientStore} from "../../stores/ClientStore";

export default {
    name: 'MyArtists',
    computed: {
        ...mapState(useClientStore, {
            listOfArtists: 'listOfArtists',
            clientId: 'clientId',
            adminPermissions: 'adminPermissions',
            hasMore() {
                return this.listOfArtists.length >= 10;
            }
        }),
    },
    data() {
        return {
            page: 1
        }
    },
    methods: {
        ...mapActions(useClientStore, {
            fetchListOfArtists: 'fetchListOfArtists',
            fetchClient: 'fetchClient',
        }),
        showMoreArtists() {
            this.page++
            this.fetchListOfArtists(this.page)
        },
        getArtistLink (id) {
            if (this.adminPermissions) {
                return `/admin/artist/${id}/show`
            } else {
                return `/client/artist/${id}`
            }
        },
        getNameOfAvatar(photo) {
            return photo ? `/uploads/${photo}` : "/img/svg/avatar.svg";
        },
    },
    watch: {
        clientId(val) {
            if (val) {
                this.fetchListOfArtists(this.page)
            }
        }
    },
    mounted() {
        if (this.clientId) {
            this.fetchListOfArtists(this.page)
        }
    }
}

</script>


<style scoped>

</style>
